export enum DistributionMethod {
  COPY_LINK = 'copy_link',
  SEND_LINK = 'send_link',
  SHOW_QR = 'show_qr',
}
